import { useUser } from '@orientaction/hooks';
import { getFromLS } from '@orientaction/utils';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { apiServiceNative } from '../../../../../utils/fetchNative';

export const useProfilePage = () => {
  const { user, updateUserById, loading, loadingUpdate, getUser, setUser } = useUser();
  const { id }: { id?: string } = useParams();
  const currentUser = JSON.parse(getFromLS('userInfos') || '{}');

  const [openRecrutementModal, setOpenRecrutementModal] = useState(false);
  const [showRecrutementBtn, setShowRecrutementBtn] = useState(false);

  useEffect(() => {
    const checkCandidature = async () => {
      const { data } = await apiServiceNative.get(
        `/api/job/find-check-candidature/${currentUser.id}`
      );
      setShowRecrutementBtn(!!data);
    };
    if (currentUser?.id) {
      checkCandidature();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (id && currentUser?.id && currentUser.id.toString() !== id.toString()) {
      window.location.replace(`/main/user/${currentUser.id}/edit`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return {
    user,
    updateUserById,
    loading,
    loadingUpdate,
    getUser,
    setUser,
    currentUser,
    openRecrutementModal,
    setOpenRecrutementModal,
    showRecrutementBtn,
  };
};
